export const GET_NEWS_LIST = "GET_NEWS_LIST";
export const SEARCH_NEWS = "SEARCH_NEWS";
export const NEWS_LETTER = "NEWS_LETTER";
export const GET_NEWS_DETAILS = "GET_NEWS_DETAILS";
export const LIKE_NEWS = "LIKE_NEWS";
export const ADD_NEWS_COMMENT = "ADD_NEWS_COMMENT";
